// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file api/gateway/v1/gateway.proto (package api.gateway.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/gateway/v1/gateway.proto.
 */
export const file_api_gateway_v1_gateway: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * @generated from message api.gateway.v1.Pagination
 */
export type Pagination = Message<"api.gateway.v1.Pagination"> & {
  /**
   * @generated from field: int32 page_index = 1;
   */
  pageIndex: number;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;
};

/**
 * Describes the message api.gateway.v1.Pagination.
 * Use `create(PaginationSchema)` to create a new message.
 */
export const PaginationSchema: GenMessage<Pagination> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 0);

/**
 * @generated from message api.gateway.v1.Metadata
 */
export type Metadata = Message<"api.gateway.v1.Metadata"> & {
  /**
   * @generated from field: int32 total_count = 1;
   */
  totalCount: number;

  /**
   * @generated from field: api.gateway.v1.Pagination pagination = 2;
   */
  pagination?: Pagination;
};

/**
 * Describes the message api.gateway.v1.Metadata.
 * Use `create(MetadataSchema)` to create a new message.
 */
export const MetadataSchema: GenMessage<Metadata> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 1);

/**
 * @generated from message api.gateway.v1.Device
 */
export type Device = Message<"api.gateway.v1.Device"> & {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Struct data = 3;
   */
  data?: JsonObject;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.gateway.v1.Device.
 * Use `create(DeviceSchema)` to create a new message.
 */
export const DeviceSchema: GenMessage<Device> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 2);

/**
 * @generated from message api.gateway.v1.DeviceGroup
 */
export type DeviceGroup = Message<"api.gateway.v1.DeviceGroup"> & {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: repeated string devices = 3;
   */
  devices: string[];

  /**
   * @generated from field: google.protobuf.Struct data = 4;
   */
  data?: JsonObject;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.gateway.v1.DeviceGroup.
 * Use `create(DeviceGroupSchema)` to create a new message.
 */
export const DeviceGroupSchema: GenMessage<DeviceGroup> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 3);

/**
 * @generated from message api.gateway.v1.CreateDeviceRequest
 */
export type CreateDeviceRequest = Message<"api.gateway.v1.CreateDeviceRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Struct data = 2;
   */
  data?: JsonObject;
};

/**
 * Describes the message api.gateway.v1.CreateDeviceRequest.
 * Use `create(CreateDeviceRequestSchema)` to create a new message.
 */
export const CreateDeviceRequestSchema: GenMessage<CreateDeviceRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 4);

/**
 * @generated from message api.gateway.v1.CreateDeviceResponse
 */
export type CreateDeviceResponse = Message<"api.gateway.v1.CreateDeviceResponse"> & {
  /**
   * @generated from field: api.gateway.v1.Device device = 1;
   */
  device?: Device;
};

/**
 * Describes the message api.gateway.v1.CreateDeviceResponse.
 * Use `create(CreateDeviceResponseSchema)` to create a new message.
 */
export const CreateDeviceResponseSchema: GenMessage<CreateDeviceResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 5);

/**
 * @generated from message api.gateway.v1.GetDeviceByUuidRequest
 */
export type GetDeviceByUuidRequest = Message<"api.gateway.v1.GetDeviceByUuidRequest"> & {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid: string;
};

/**
 * Describes the message api.gateway.v1.GetDeviceByUuidRequest.
 * Use `create(GetDeviceByUuidRequestSchema)` to create a new message.
 */
export const GetDeviceByUuidRequestSchema: GenMessage<GetDeviceByUuidRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 6);

/**
 * @generated from message api.gateway.v1.GetDeviceByUuidResponse
 */
export type GetDeviceByUuidResponse = Message<"api.gateway.v1.GetDeviceByUuidResponse"> & {
  /**
   * @generated from field: api.gateway.v1.Device device = 1;
   */
  device?: Device;
};

/**
 * Describes the message api.gateway.v1.GetDeviceByUuidResponse.
 * Use `create(GetDeviceByUuidResponseSchema)` to create a new message.
 */
export const GetDeviceByUuidResponseSchema: GenMessage<GetDeviceByUuidResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 7);

/**
 * @generated from message api.gateway.v1.GetDeviceListByPageRequest
 */
export type GetDeviceListByPageRequest = Message<"api.gateway.v1.GetDeviceListByPageRequest"> & {
  /**
   * @generated from field: int32 page_index = 1;
   */
  pageIndex: number;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;
};

/**
 * Describes the message api.gateway.v1.GetDeviceListByPageRequest.
 * Use `create(GetDeviceListByPageRequestSchema)` to create a new message.
 */
export const GetDeviceListByPageRequestSchema: GenMessage<GetDeviceListByPageRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 8);

/**
 * @generated from message api.gateway.v1.GetDeviceListByPageResponse
 */
export type GetDeviceListByPageResponse = Message<"api.gateway.v1.GetDeviceListByPageResponse"> & {
  /**
   * @generated from field: repeated api.gateway.v1.Device data = 1;
   */
  data: Device[];

  /**
   * @generated from field: api.gateway.v1.Metadata metadata = 2;
   */
  metadata?: Metadata;
};

/**
 * Describes the message api.gateway.v1.GetDeviceListByPageResponse.
 * Use `create(GetDeviceListByPageResponseSchema)` to create a new message.
 */
export const GetDeviceListByPageResponseSchema: GenMessage<GetDeviceListByPageResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 9);

/**
 * @generated from message api.gateway.v1.UpdateDeviceRequest
 */
export type UpdateDeviceRequest = Message<"api.gateway.v1.UpdateDeviceRequest"> & {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Struct data = 3;
   */
  data?: JsonObject;
};

/**
 * Describes the message api.gateway.v1.UpdateDeviceRequest.
 * Use `create(UpdateDeviceRequestSchema)` to create a new message.
 */
export const UpdateDeviceRequestSchema: GenMessage<UpdateDeviceRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 10);

/**
 * @generated from message api.gateway.v1.UpdateDeviceResponse
 */
export type UpdateDeviceResponse = Message<"api.gateway.v1.UpdateDeviceResponse"> & {
  /**
   * @generated from field: api.gateway.v1.Device device = 1;
   */
  device?: Device;
};

/**
 * Describes the message api.gateway.v1.UpdateDeviceResponse.
 * Use `create(UpdateDeviceResponseSchema)` to create a new message.
 */
export const UpdateDeviceResponseSchema: GenMessage<UpdateDeviceResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 11);

/**
 * @generated from message api.gateway.v1.DeleteDeviceRequest
 */
export type DeleteDeviceRequest = Message<"api.gateway.v1.DeleteDeviceRequest"> & {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid: string;
};

/**
 * Describes the message api.gateway.v1.DeleteDeviceRequest.
 * Use `create(DeleteDeviceRequestSchema)` to create a new message.
 */
export const DeleteDeviceRequestSchema: GenMessage<DeleteDeviceRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 12);

/**
 * @generated from message api.gateway.v1.DeleteDeviceResponse
 */
export type DeleteDeviceResponse = Message<"api.gateway.v1.DeleteDeviceResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message api.gateway.v1.DeleteDeviceResponse.
 * Use `create(DeleteDeviceResponseSchema)` to create a new message.
 */
export const DeleteDeviceResponseSchema: GenMessage<DeleteDeviceResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 13);

/**
 * @generated from message api.gateway.v1.GetDeviceTopicListRequest
 */
export type GetDeviceTopicListRequest = Message<"api.gateway.v1.GetDeviceTopicListRequest"> & {
  /**
   * @generated from field: string device_uuid = 1;
   */
  deviceUuid: string;
};

/**
 * Describes the message api.gateway.v1.GetDeviceTopicListRequest.
 * Use `create(GetDeviceTopicListRequestSchema)` to create a new message.
 */
export const GetDeviceTopicListRequestSchema: GenMessage<GetDeviceTopicListRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 14);

/**
 * @generated from message api.gateway.v1.GetDeviceTopicListResponse
 */
export type GetDeviceTopicListResponse = Message<"api.gateway.v1.GetDeviceTopicListResponse"> & {
  /**
   * @generated from field: repeated string topics = 1;
   */
  topics: string[];
};

/**
 * Describes the message api.gateway.v1.GetDeviceTopicListResponse.
 * Use `create(GetDeviceTopicListResponseSchema)` to create a new message.
 */
export const GetDeviceTopicListResponseSchema: GenMessage<GetDeviceTopicListResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 15);

/**
 * @generated from message api.gateway.v1.GetDeviceDataTelemetryRequest
 */
export type GetDeviceDataTelemetryRequest = Message<"api.gateway.v1.GetDeviceDataTelemetryRequest"> & {
  /**
   * @generated from field: string device_uuid = 1;
   */
  deviceUuid: string;

  /**
   * @generated from field: string topic = 2;
   */
  topic: string;

  /**
   * @generated from field: api.gateway.v1.Pagination pagination = 3;
   */
  pagination?: Pagination;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 4;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 5;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: api.gateway.v1.AggregationType aggregation = 6;
   */
  aggregation: AggregationType;

  /**
   * Unused if aggregation is AGGREGATION_UNSPECIFIED
   *
   * @generated from field: int64 interval_seconds = 7;
   */
  intervalSeconds: bigint;

  /**
   * Always ordered by timestamp
   *
   * @generated from field: bool ascending = 8;
   */
  ascending: boolean;
};

/**
 * Describes the message api.gateway.v1.GetDeviceDataTelemetryRequest.
 * Use `create(GetDeviceDataTelemetryRequestSchema)` to create a new message.
 */
export const GetDeviceDataTelemetryRequestSchema: GenMessage<GetDeviceDataTelemetryRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 16);

/**
 * @generated from message api.gateway.v1.DataTelemetry
 */
export type DataTelemetry = Message<"api.gateway.v1.DataTelemetry"> & {
  /**
   * @generated from field: string device_uuid = 1;
   */
  deviceUuid: string;

  /**
   * @generated from field: string topic = 2;
   */
  topic: string;

  /**
   * @generated from field: google.protobuf.Struct data = 3;
   */
  data?: JsonObject;

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 4;
   */
  timestamp?: Timestamp;
};

/**
 * Describes the message api.gateway.v1.DataTelemetry.
 * Use `create(DataTelemetrySchema)` to create a new message.
 */
export const DataTelemetrySchema: GenMessage<DataTelemetry> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 17);

/**
 * @generated from message api.gateway.v1.GetDeviceDataTelemetryResponse
 */
export type GetDeviceDataTelemetryResponse = Message<"api.gateway.v1.GetDeviceDataTelemetryResponse"> & {
  /**
   * @generated from field: repeated api.gateway.v1.DataTelemetry data_telemetry = 1;
   */
  dataTelemetry: DataTelemetry[];

  /**
   * @generated from field: api.gateway.v1.Metadata metadata = 2;
   */
  metadata?: Metadata;
};

/**
 * Describes the message api.gateway.v1.GetDeviceDataTelemetryResponse.
 * Use `create(GetDeviceDataTelemetryResponseSchema)` to create a new message.
 */
export const GetDeviceDataTelemetryResponseSchema: GenMessage<GetDeviceDataTelemetryResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 18);

/**
 * @generated from message api.gateway.v1.GetDeviceDataKPIsRequest
 */
export type GetDeviceDataKPIsRequest = Message<"api.gateway.v1.GetDeviceDataKPIsRequest"> & {
  /**
   * @generated from field: string device_uuid = 1;
   */
  deviceUuid: string;

  /**
   * @generated from field: string topic = 2;
   */
  topic: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 3;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 4;
   */
  endTime?: Timestamp;
};

/**
 * Describes the message api.gateway.v1.GetDeviceDataKPIsRequest.
 * Use `create(GetDeviceDataKPIsRequestSchema)` to create a new message.
 */
export const GetDeviceDataKPIsRequestSchema: GenMessage<GetDeviceDataKPIsRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 19);

/**
 * @generated from message api.gateway.v1.GetDeviceDataKPIsResponse
 */
export type GetDeviceDataKPIsResponse = Message<"api.gateway.v1.GetDeviceDataKPIsResponse"> & {
  /**
   * @generated from field: int64 total_alerts = 1;
   */
  totalAlerts: bigint;

  /**
   * @generated from field: int64 total_events = 2;
   */
  totalEvents: bigint;

  /**
   * @generated from field: string most_used_command = 3;
   */
  mostUsedCommand: string;
};

/**
 * Describes the message api.gateway.v1.GetDeviceDataKPIsResponse.
 * Use `create(GetDeviceDataKPIsResponseSchema)` to create a new message.
 */
export const GetDeviceDataKPIsResponseSchema: GenMessage<GetDeviceDataKPIsResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 20);

/**
 * @generated from message api.gateway.v1.DeviceKPI
 */
export type DeviceKPI = Message<"api.gateway.v1.DeviceKPI"> & {
  /**
   * @generated from field: string device_uuid = 1;
   */
  deviceUuid: string;

  /**
   * @generated from field: double kpi_value = 2;
   */
  kpiValue: number;

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 3;
   */
  timestamp?: Timestamp;
};

/**
 * Describes the message api.gateway.v1.DeviceKPI.
 * Use `create(DeviceKPISchema)` to create a new message.
 */
export const DeviceKPISchema: GenMessage<DeviceKPI> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 21);

/**
 * @generated from message api.gateway.v1.LoginRequest
 */
export type LoginRequest = Message<"api.gateway.v1.LoginRequest"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message api.gateway.v1.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 22);

/**
 * @generated from message api.gateway.v1.LoginResponse
 */
export type LoginResponse = Message<"api.gateway.v1.LoginResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;
};

/**
 * Describes the message api.gateway.v1.LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema: GenMessage<LoginResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 23);

/**
 * @generated from message api.gateway.v1.LogoutRequest
 */
export type LogoutRequest = Message<"api.gateway.v1.LogoutRequest"> & {
  /**
   * @generated from field: string refresh_token = 1;
   */
  refreshToken: string;
};

/**
 * Describes the message api.gateway.v1.LogoutRequest.
 * Use `create(LogoutRequestSchema)` to create a new message.
 */
export const LogoutRequestSchema: GenMessage<LogoutRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 24);

/**
 * @generated from message api.gateway.v1.LogoutResponse
 */
export type LogoutResponse = Message<"api.gateway.v1.LogoutResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message api.gateway.v1.LogoutResponse.
 * Use `create(LogoutResponseSchema)` to create a new message.
 */
export const LogoutResponseSchema: GenMessage<LogoutResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 25);

/**
 * @generated from message api.gateway.v1.RegisterRequest
 */
export type RegisterRequest = Message<"api.gateway.v1.RegisterRequest"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;
};

/**
 * Describes the message api.gateway.v1.RegisterRequest.
 * Use `create(RegisterRequestSchema)` to create a new message.
 */
export const RegisterRequestSchema: GenMessage<RegisterRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 26);

/**
 * @generated from message api.gateway.v1.RegisterResponse
 */
export type RegisterResponse = Message<"api.gateway.v1.RegisterResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;
};

/**
 * Describes the message api.gateway.v1.RegisterResponse.
 * Use `create(RegisterResponseSchema)` to create a new message.
 */
export const RegisterResponseSchema: GenMessage<RegisterResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 27);

/**
 * @generated from message api.gateway.v1.CheckTokenRequest
 */
export type CheckTokenRequest = Message<"api.gateway.v1.CheckTokenRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message api.gateway.v1.CheckTokenRequest.
 * Use `create(CheckTokenRequestSchema)` to create a new message.
 */
export const CheckTokenRequestSchema: GenMessage<CheckTokenRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 28);

/**
 * @generated from message api.gateway.v1.CheckTokenResponse
 */
export type CheckTokenResponse = Message<"api.gateway.v1.CheckTokenResponse"> & {
  /**
   * @generated from field: bool token_valid = 1;
   */
  tokenValid: boolean;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string username = 3;
   */
  username: string;

  /**
   * @generated from field: repeated string roles = 4;
   */
  roles: string[];
};

/**
 * Describes the message api.gateway.v1.CheckTokenResponse.
 * Use `create(CheckTokenResponseSchema)` to create a new message.
 */
export const CheckTokenResponseSchema: GenMessage<CheckTokenResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 29);

/**
 * @generated from message api.gateway.v1.RefreshTokenRequest
 */
export type RefreshTokenRequest = Message<"api.gateway.v1.RefreshTokenRequest"> & {
  /**
   * @generated from field: string refresh_token = 1;
   */
  refreshToken: string;
};

/**
 * Describes the message api.gateway.v1.RefreshTokenRequest.
 * Use `create(RefreshTokenRequestSchema)` to create a new message.
 */
export const RefreshTokenRequestSchema: GenMessage<RefreshTokenRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 30);

/**
 * @generated from message api.gateway.v1.RefreshTokenResponse
 */
export type RefreshTokenResponse = Message<"api.gateway.v1.RefreshTokenResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;
};

/**
 * Describes the message api.gateway.v1.RefreshTokenResponse.
 * Use `create(RefreshTokenResponseSchema)` to create a new message.
 */
export const RefreshTokenResponseSchema: GenMessage<RefreshTokenResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 31);

/**
 * @generated from message api.gateway.v1.GetUserByUuidRequest
 */
export type GetUserByUuidRequest = Message<"api.gateway.v1.GetUserByUuidRequest"> & {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid: string;
};

/**
 * Describes the message api.gateway.v1.GetUserByUuidRequest.
 * Use `create(GetUserByUuidRequestSchema)` to create a new message.
 */
export const GetUserByUuidRequestSchema: GenMessage<GetUserByUuidRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 32);

/**
 * @generated from message api.gateway.v1.GetUserByUuidResponse
 */
export type GetUserByUuidResponse = Message<"api.gateway.v1.GetUserByUuidResponse"> & {
  /**
   * @generated from field: api.gateway.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message api.gateway.v1.GetUserByUuidResponse.
 * Use `create(GetUserByUuidResponseSchema)` to create a new message.
 */
export const GetUserByUuidResponseSchema: GenMessage<GetUserByUuidResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 33);

/**
 * @generated from message api.gateway.v1.GetUserByEmailRequest
 */
export type GetUserByEmailRequest = Message<"api.gateway.v1.GetUserByEmailRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message api.gateway.v1.GetUserByEmailRequest.
 * Use `create(GetUserByEmailRequestSchema)` to create a new message.
 */
export const GetUserByEmailRequestSchema: GenMessage<GetUserByEmailRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 34);

/**
 * @generated from message api.gateway.v1.GetUserByEmailResponse
 */
export type GetUserByEmailResponse = Message<"api.gateway.v1.GetUserByEmailResponse"> & {
  /**
   * @generated from field: api.gateway.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message api.gateway.v1.GetUserByEmailResponse.
 * Use `create(GetUserByEmailResponseSchema)` to create a new message.
 */
export const GetUserByEmailResponseSchema: GenMessage<GetUserByEmailResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 35);

/**
 * @generated from message api.gateway.v1.User
 */
export type User = Message<"api.gateway.v1.User"> & {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string username = 3;
   */
  username: string;
};

/**
 * Describes the message api.gateway.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_gateway, 36);

/**
 * @generated from enum api.gateway.v1.AggregationType
 */
export enum AggregationType {
  /**
   * No aggregation / raw data
   *
   * @generated from enum value: AGGREGATION_UNSPECIFIED = 0;
   */
  AGGREGATION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: FIRST = 1;
   */
  FIRST = 1,

  /**
   * @generated from enum value: LAST = 2;
   */
  LAST = 2,

  /**
   * @generated from enum value: AVG = 3;
   */
  AVG = 3,

  /**
   * @generated from enum value: MIN = 4;
   */
  MIN = 4,

  /**
   * @generated from enum value: MAX = 5;
   */
  MAX = 5,
}

/**
 * Describes the enum api.gateway.v1.AggregationType.
 */
export const AggregationTypeSchema: GenEnum<AggregationType> = /*@__PURE__*/
  enumDesc(file_api_gateway_v1_gateway, 0);

/**
 * Services
 *
 * @generated from service api.gateway.v1.GatewayServices
 */
export const GatewayServices: GenService<{
  /**
   * Devices
   *
   * @generated from rpc api.gateway.v1.GatewayServices.CreateDevice
   */
  createDevice: {
    methodKind: "unary";
    input: typeof CreateDeviceRequestSchema;
    output: typeof CreateDeviceResponseSchema;
  },
  /**
   * @generated from rpc api.gateway.v1.GatewayServices.GetDeviceByUuid
   */
  getDeviceByUuid: {
    methodKind: "unary";
    input: typeof GetDeviceByUuidRequestSchema;
    output: typeof GetDeviceByUuidResponseSchema;
  },
  /**
   * @generated from rpc api.gateway.v1.GatewayServices.GetDeviceListByPage
   */
  getDeviceListByPage: {
    methodKind: "unary";
    input: typeof GetDeviceListByPageRequestSchema;
    output: typeof GetDeviceListByPageResponseSchema;
  },
  /**
   * @generated from rpc api.gateway.v1.GatewayServices.UpdateDevice
   */
  updateDevice: {
    methodKind: "unary";
    input: typeof UpdateDeviceRequestSchema;
    output: typeof UpdateDeviceResponseSchema;
  },
  /**
   * @generated from rpc api.gateway.v1.GatewayServices.DeleteDevice
   */
  deleteDevice: {
    methodKind: "unary";
    input: typeof DeleteDeviceRequestSchema;
    output: typeof DeleteDeviceResponseSchema;
  },
  /**
   * Device data
   *
   * @generated from rpc api.gateway.v1.GatewayServices.GetDeviceTopicList
   */
  getDeviceTopicList: {
    methodKind: "unary";
    input: typeof GetDeviceTopicListRequestSchema;
    output: typeof GetDeviceTopicListResponseSchema;
  },
  /**
   * @generated from rpc api.gateway.v1.GatewayServices.GetDeviceDataTelemetry
   */
  getDeviceDataTelemetry: {
    methodKind: "unary";
    input: typeof GetDeviceDataTelemetryRequestSchema;
    output: typeof GetDeviceDataTelemetryResponseSchema;
  },
  /**
   * @generated from rpc api.gateway.v1.GatewayServices.GetDeviceDataKPIs
   */
  getDeviceDataKPIs: {
    methodKind: "unary";
    input: typeof GetDeviceDataKPIsRequestSchema;
    output: typeof GetDeviceDataKPIsResponseSchema;
  },
  /**
   * Authentication
   *
   * @generated from rpc api.gateway.v1.GatewayServices.Login
   */
  login: {
    methodKind: "unary";
    input: typeof LoginRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * @generated from rpc api.gateway.v1.GatewayServices.Logout
   */
  logout: {
    methodKind: "unary";
    input: typeof LogoutRequestSchema;
    output: typeof LogoutResponseSchema;
  },
  /**
   * @generated from rpc api.gateway.v1.GatewayServices.Register
   */
  register: {
    methodKind: "unary";
    input: typeof RegisterRequestSchema;
    output: typeof RegisterResponseSchema;
  },
  /**
   * @generated from rpc api.gateway.v1.GatewayServices.CheckToken
   */
  checkToken: {
    methodKind: "unary";
    input: typeof CheckTokenRequestSchema;
    output: typeof CheckTokenResponseSchema;
  },
  /**
   * @generated from rpc api.gateway.v1.GatewayServices.RefreshToken
   */
  refreshToken: {
    methodKind: "unary";
    input: typeof RefreshTokenRequestSchema;
    output: typeof RefreshTokenResponseSchema;
  },
  /**
   * User Management
   *
   * @generated from rpc api.gateway.v1.GatewayServices.GetUserByUuid
   */
  getUserByUuid: {
    methodKind: "unary";
    input: typeof GetUserByUuidRequestSchema;
    output: typeof GetUserByUuidResponseSchema;
  },
  /**
   * @generated from rpc api.gateway.v1.GatewayServices.GetUserByEmail
   */
  getUserByEmail: {
    methodKind: "unary";
    input: typeof GetUserByEmailRequestSchema;
    output: typeof GetUserByEmailResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_gateway_v1_gateway, 0);

